"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useMenu = _interopRequireDefault(require("./hooks/useMenu"));
var _MenuContext = _interopRequireDefault(require("./contexts/MenuContext"));
var _Popover = _interopRequireDefault(require("../Popover"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    show = props.show,
    anchor = props.anchor,
    _a = props.shouldFocusOnClose,
    shouldFocusOnClose = _a === void 0 ? true : _a,
    onClickOutside = props.onClickOutside,
    listProps = props.listProps,
    filterdProps = __rest(props, ["children", "show", "anchor", "shouldFocusOnClose", "onClickOutside", "listProps"]);
  var previousIsOpenState = (0, _react.useRef)(false);
  var menuContext = (0, _useMenu.default)();
  var _b = (0, _react.useState)([]),
    activeSubMenus = _b[0],
    setActiveSubMenus = _b[1];
  var _c = (0, _react.useState)(),
    listRef = _c[0],
    setListRef = _c[1];
  (0, _react.useEffect)(function () {
    if (shouldFocusOnClose && !show && previousIsOpenState.current && anchor) {
      anchor.focus();
    }
    previousIsOpenState.current = show;
  }, [shouldFocusOnClose, show, anchor]);
  (0, _react.useEffect)(function () {
    if (show && listRef) {
      if (document.activeElement !== listRef) {
        listRef.focus();
      }
    }
  }, [show, listRef]);
  var handleListRef = (0, _react.useCallback)(function (list) {
    setListRef(list);
    if (listProps === null || listProps === void 0 ? void 0 : listProps.ref) {
      if (typeof listProps.ref === 'function') {
        listProps.ref(list);
      } else {
        // @ts-ignore
        listProps.ref.current = list;
      }
    }
  }, [listProps]);
  var handleOnClickOutside = (0, _react.useCallback)(function (event) {
    if (typeof onClickOutside === 'function') {
      onClickOutside(event);
    }
  }, [onClickOutside]);
  var handleAddActiveSubMenu = (0, _react.useCallback)(function (id) {
    setActiveSubMenus(function (current) {
      return __spreadArray(__spreadArray([], current, true), [id], false);
    });
  }, []);
  var handleRemoveActiveSubMenu = (0, _react.useCallback)(function (id) {
    setActiveSubMenus(function (current) {
      return current.filter(function (i) {
        return i !== id;
      });
    });
  }, []);
  var menuContextValue = (0, _react.useMemo)(function () {
    return menuContext || {
      activeSubMenuId: activeSubMenus[activeSubMenus.length - 1],
      onClickOutside: handleOnClickOutside,
      addSubMenu: handleAddActiveSubMenu,
      removeSubMenu: handleRemoveActiveSubMenu
    };
  }, [menuContext, activeSubMenus, handleOnClickOutside, handleAddActiveSubMenu, handleRemoveActiveSubMenu]);
  return (0, _jsxRuntime.jsx)(_MenuContext.default.Provider, __assign({
    value: menuContextValue
  }, {
    children: (0, _jsxRuntime.jsx)(_Popover.default, __assign({
      ref: ref
    }, filterdProps, {
      show: show,
      anchor: anchor,
      onClickOutside: handleOnClickOutside
    }, {
      children: (0, _jsxRuntime.jsx)(Styled.List, __assign({
        ref: handleListRef
      }, listProps, {
        children: children
      }))
    }))
  }));
});
Menu.displayName = 'Menu';
var _default = Menu;
exports.default = _default;